import { LABEL_TYPE } from "../label/labelTypes";

import { NEW_BADGE_KEY } from "./constants";

export default function getNewBadge(translate) {
  return {
    type: LABEL_TYPE.NEW,
    text: translate(NEW_BADGE_KEY)
  };
}

export function getNewBadgeIfIsNew(isNew, translate) {
  if (isNew !== true) {
    return undefined;
  }

  return getNewBadge(translate);
}
